<template>
  <MetricCard
    apiEndpoint="/youtube-analytics/average-view-duration"
    metricName="AVG VIEW DURATION"
    :formatData="formatData"
    srcName="YouTube Analytics"
  />
</template>

<script setup>
import MetricCard from '@/components/MetricCard.vue';
const formatData = (data) => data?.data;
</script>
